<div class="flex flex-col h-full">
    <ul class="layout-menu flex-grow px-3">
        <ng-container *ngFor="let item of model; let i = index">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
            <li *ngIf="item.separator" class="menu-separator mx-2"></li>
        </ng-container>
    </ul>

    <div
        class="mt-auto px-3 mb-6 p-5 rounded-2xl bg-surface-100/50 dark:bg-surface-800/40 border border-surface-200/60 dark:border-surface-700/50 backdrop-blur-sm">
        <div class="flex flex-col gap-4">

            <!-- Status de Armazenamento -->
            <div class="flex justify-between items-center">
                <div class="flex items-center gap-2">
                    <div
                        class="flex items-center justify-center w-7 h-7 rounded-lg bg-white dark:bg-surface-900 shadow-sm border border-surface-100 dark:border-surface-800">
                        <i class="pi pi-database text-[10px]" style="color: var(--primary-color)"></i>
                    </div>
                    <span class="text-[10px] uppercase tracking-widest font-bold text-surface-500">
                        STATUS DE ARMAZENAMENTO
                    </span>
                </div>
                <span
                    class="text-[10px] font-bold px-2 py-0.5 rounded-md bg-white dark:bg-surface-900 text-surface-700 dark:text-surface-200 shadow-sm border border-surface-100 dark:border-surface-800">
                    1%
                </span>
            </div>

            <!-- Barra de Progresso -->
            <div class="relative w-full h-1.5 bg-surface-300 dark:bg-surface-700 rounded-full overflow-hidden">
                <div class="h-full rounded-full transition-all duration-1000 ease-out" [style.width.%]="1" style="background-color: var(--primary-color);
                        box-shadow: 0 0 10px rgba(var(--primary-color-rgb, 0,0,0), 0.2);">
                </div>
            </div>

            <!-- Detalhes de Armazenamento -->
            <div class="flex justify-between items-center">
                <div class="text-[10px] font-medium text-surface-600 dark:text-surface-400">
                    <span class="text-surface-900 dark:text-surface-0 font-bold">0.5 GB</span>
                    <span class="opacity-50 ml-1">/ 15 GB</span>
                </div>
                <i class="pi pi-cog text-[10px] text-surface-400 hover:text-primary transition-colors cursor-pointer"
                    pTooltip="Gerenciar" tooltipPosition="top">
                </i>
            </div>

            <!-- Plano Atual e Upgrade -->
            <div
                class="flex flex-col mt-3 p-3 bg-surface-200/50 dark:bg-surface-700/40 rounded-xl border border-surface-300 dark:border-surface-600 items-center gap-3">

                <!-- Texto do plano -->
                <div class="text-[10px] font-medium text-surface-700 dark:text-surface-200 mb-2">
                    Você está no plano
                    <span class="font-bold text-primary">Free</span>
                </div>

                <!-- Botão full width -->
                 <p-button label="Fazer Upgrade" styleClass="w-full text-[10px] font-bold py-2 rounded-lg bg-primary text-white hover:bg-primary-dark transition-colors" (click)="navigateToPlans()"></p-button>
            </div>
        </div>
    </div>